module.exports = __webpack_public_path__ + "img/pdf.6958a34b.svg";